export default __webpack_public_path__ + "static/media/nbg.cbbb7d64.png";